import React from "react";
import { LoopDiagram } from "@/components/adaptive-loop/RegulationLoops";

const AdaptiveLoopHeader = ({
  testId = "adaptive-loop-header",
  className = "",
}) => (
  <div
    data-testid={testId}
    className={`w-full max-w-[350px] ${className}`}
  >
    <LoopDiagram
      variant="adaptive"
      size="compact"
      showDescriptions={false}
      testId={`${testId}-diagram`}
    />
  </div>
);

export default AdaptiveLoopHeader;
